module.exports = __webpack_public_path__ + "static/sibriex-59888c39a9fb7760dad4f305c680d643.png";